import { useReqdeskContext } from './ReqdeskProvider'
import { useReqdesk } from './useReqdesk'
import { themeToStyle } from '../theme'
import { ShadowRoot } from './shadow-root'
import type { SupportPortalProps } from './types'

export function SupportPortal({ className }: SupportPortalProps) {
  const ctx = useReqdeskContext()
  const { isLoading } = useReqdesk()
  const cssVars = themeToStyle(ctx.theme)

  return (
    <ShadowRoot>
      <div className={`rqd-inline ${className ?? ''}`} style={cssVars as React.CSSProperties}>
        <div className="rqd-body">
          {isLoading ? (
            <p style={{ textAlign: 'center', color: 'var(--rqd-text-secondary)' }}>Loading...</p>
          ) : (
            <p style={{ textAlign: 'center', color: 'var(--rqd-text-secondary)', padding: '24px 0' }}>
              Support Portal — coming in a future update.
            </p>
          )}
        </div>
      </div>
    </ShadowRoot>
  )
}
